import AdobeEventPageType from '~/constants/dealership/AdobeEventPageType';
import type { EventVehicle } from '~/contracts/dealership';

type Extras = {
  vehicle?: EventVehicle;
};

export default function getAdobeEventPageName(
  type: AdobeEventPageType,
  extras: Extras
): string {
  switch (type) {
    case AdobeEventPageType.Home:
      return 'homepage';
    case AdobeEventPageType.Other:
      return window.location.pathname.split('/').join(':');
    case AdobeEventPageType.Service:
      return 'services:services';
    case AdobeEventPageType.VehicleDetails: {
      const { vehicle } = extras;

      return `${vehicle?.year}:${vehicle?.model?.toLowerCase()}:vehicle-details`;
    }
    case AdobeEventPageType.VehicleListing:
      return 'search-inventory:other-inventory';
  }
}
